
import React from 'react';
import { FormattedMessage } from 'react-intl';
import CopyLinkComponent from '../widgets/copy-link-com.jsx';
import { Drafty } from 'tinode-sdk';
import { fullFormatter } from '../lib/formatters.js';

export default class ProblemMessage extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let content = this.props.content.trim();
    let advice = this.props.advice;
    let isAdviceHTML = false;
    let bubbleClass = 'bubble';
    let plan = "";

    if (!content) {
      return <>{null}</>
    }


    if (
      this.props.topic &&
      this.props.topic.private &&
      this.props.topic.private.plandialog &&
      this.props.topic.public &&
      this.props.topic.public.numdialog
    ) {
      try {
        // Преобразуем строку JSON в массив объектов
        const data = JSON.parse(this.props.topic.private.plandialog);
    
        // Проверяем, что данные являются массивом
        if (!Array.isArray(data)) {
          throw new Error("Некорректный формат данных: должен быть массив");
        }
    
        // Находим объект с нужным ssn
        const foundPlan = data.find(
          (item) => item.ssn === this.props.topic.public.numdialog
        );
    
        // Если объект найден, присваиваем его topic переменной plan, иначе оставляем пустым
        plan = foundPlan ? foundPlan.topic : "";
      } catch (error) {
        // В случае ошибки план остаётся пустой. Можно залогировать ошибку, если нужно.
        console.error("Ошибка при обработке плана:", error);
      }
    }
    

    //console.info("advice",advice)

    if (advice) {
        const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
        if  (htmlTagPattern.test(advice)) {
          isAdviceHTML = true

        } else {
            const tree = Drafty.format(advice, fullFormatter, {
                        formatMessage: this.props.intl.formatMessage.bind(this.props.intl),
                        viewportWidth: null,
                        authorizeURL: this.props.tinode.authorizeURL.bind(this.props.tinode),

                        onImagePreview: null,
                        onVideoPreview: null,
                        onFormButtonClick: null,
                        onQuoteClick: null
                      });
            advice = React.createElement(React.Fragment, null, tree);
        }
    }

    return (
      <div>
      <div className="card">
       
          <div className="message-content">
          <b>
          <FormattedMessage id="label_private" defaultMessage="Private comment"
                      description="Label for editing 'private'" />:</b>
            {/*" " + content.replace(/\n/g, '<br />')*/}

            <div   dangerouslySetInnerHTML={{ __html: content.replace(/\n/g, '<br />') }} />
          </div>

          {plan &&
            <div>
              <br/>
              <b>
              <FormattedMessage id="message.currentnumplan" defaultMessage="Loading.."
                              description="Label" />:</b> {plan}
            </div>  
          
          } 

          {this.props.topic.public && !this.props.topic.public.numdialog &&
            <div>
              <br/>
              <FormattedMessage id="message.sess0" defaultMessage="Loading.."
                              description="Label" />
            </div>  
          }
         
      
      </div>

      { advice &&
      <div className="card">
       
          <div className="message-content">
            <b>
          <FormattedMessage id="advice_title" defaultMessage="Tips for solving"
                      description="Tips for solving" /> </b> <br/>  <br/>
            {isAdviceHTML ?     
            <div className="advice-in-message"  dangerouslySetInnerHTML={{ __html: advice.replace(/\n/g, '<br />') }} />
            : advice
            }
          
          </div>
         
      
      </div>}

      {this.props.typeDialog == 1 &&
          <div className="card">
            
              <FormattedMessage id="topic_link" defaultMessage="Link for join:"
                              description="Link for join:" /> 

              <CopyLinkComponent topicName={this.props.topicname} />
              <br/>
              {this.props.locale == "ru" ?
              <a href="/#how" target="_blank">
                  <FormattedMessage id="how_invite_work" defaultMessage="How it works?"
                              description="How it works?" /> 
              </a> :
              <a href="/en.html#how" target="_blank">
              <FormattedMessage id="how_invite_work" defaultMessage="How it works?"
                          description="How it works?" /> 
              </a>}


              
            

          </div>}

   
      </div>

      
    );

    /*
    return (
      <div>
      <li className="meta">
        <div className={bubbleClass}>
          <div className="message-content">
          <FormattedMessage id="label_private" defaultMessage="Private comment"
                      description="Label for editing 'private'" />:
            {content}
          </div>
          {' '}
         
        </div>
      </li>
      <li className="meta">
        <div className={bubbleClass}>
          <FormattedMessage id="topic_link" defaultMessage="Link for join:"
                          description="Link for join:" /> 

          <CopyLinkComponent topicName={this.props.topicname} />
          
          </div>

      </li>
      </div>

      
    );*/
  }
};
